module.exports = __webpack_public_path__ + "static/screenshot4-023f899bc457b1bd85cbc8ac33167188.png";